/* unplugin-vue-components disabled */import { render } from "./SolanaLogo.vue?vue&type=template&id=4bed256e"
const script = {}

import "./SolanaLogo.vue?vue&type=style&index=0&id=4bed256e&lang=css"

import exportComponent from "G:\\Projects\\Ornn\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.4.0_webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__